export const NAMESPACE = 'meta';
export const META_BASE = `${NAMESPACE}/META_BASE`;
export const SET_META_DATA = `${NAMESPACE}/SET_META_DATA`;
